/** @jsxImportSource @emotion/react */
"use client";

import { css } from "@emotion/react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";

const itemStyle = css({
  overflow: "hidden",
});

export function AccordionItem({
  children,
  value,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Item>) {
  return (
    <AccordionPrimitive.Item value={value} css={itemStyle} {...props}>
      {children}
    </AccordionPrimitive.Item>
  );
}
